import React from 'react';
// styles
import styled from 'styled-components';

const AddIcon = ({ className, ...props }) => (
  <svg
    {...props}
    aria-label="Add"
    className={className}
    role="img"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 8C0.5 8.55228 0.947715 9 1.5 9H7.33333C7.42538 9 7.5 9.07462 7.5 9.16667V15C7.5 15.5523 7.94772 16 8.5 16C9.05228 16 9.5 15.5523 9.5 15V9.16667C9.5 9.07462 9.57462 9 9.66667 9H15.5C16.0523 9 16.5 8.55228 16.5 8C16.5 7.44772 16.0523 7 15.5 7H9.66667C9.57462 7 9.5 6.92538 9.5 6.83333V1C9.5 0.447715 9.05228 0 8.5 0C7.94772 0 7.5 0.447715 7.5 1V6.83333C7.5 6.92538 7.42538 7 7.33333 7H1.5C0.947715 7 0.5 7.44772 0.5 8Z"
      fill="white"
    />
    <mask
      id="mask0_2549_35435"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="17"
      height="16"
    >
      <path
        d="M0.5 8C0.5 8.55228 0.947715 9 1.5 9H7.33333C7.42538 9 7.5 9.07462 7.5 9.16667V15C7.5 15.5523 7.94772 16 8.5 16C9.05228 16 9.5 15.5523 9.5 15V9.16667C9.5 9.07462 9.57462 9 9.66667 9H15.5C16.0523 9 16.5 8.55228 16.5 8C16.5 7.44772 16.0523 7 15.5 7H9.66667C9.57462 7 9.5 6.92538 9.5 6.83333V1C9.5 0.447715 9.05228 0 8.5 0C7.94772 0 7.5 0.447715 7.5 1V6.83333C7.5 6.92538 7.42538 7 7.33333 7H1.5C0.947715 7 0.5 7.44772 0.5 8Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_2549_35435)"></g>
  </svg>
);

export default styled(AddIcon)``;
